import { CheckIcon, RadioCheckIcon, RadioUnCheckIcon } from "../../../assets/icons";
import styles from "./RadioButtonLong.module.scss";
export interface RadioButtonLong {
	leftSection?: React.ReactNode;
	middleSection?: React.ReactNode;
	isSelected: boolean;
	onSelected: () => void;
	label?: string;
	subLabel?: string;
    isHidden?: boolean;
}
const RadioButtonLong: React.FC<RadioButtonLong> = ({ leftSection, middleSection, isSelected, onSelected, label, subLabel, isHidden= false }) => {
	return (
		<div className={styles.radioContainer} onClick={onSelected}>
			{label && <label className={styles.label}>{label}</label>}
			{subLabel && <label className={styles.subLabel}>{subLabel}</label>}
			<div className={styles.radioContent}>
				<div>{leftSection}</div>
				<div>{middleSection}</div>
				{!isHidden &&<div>
					 <>
                    <input checked={isSelected} onChange={onSelected} type="radio" hidden />
					{isSelected ? <RadioCheckIcon /> : <RadioUnCheckIcon />}
                    </>
				</div>}
			</div>
		</div>
	);
};
export default RadioButtonLong;
